import {Dish} from "../Types/Dish";

const BASE_URL = `${process.env.REACT_APP_API_URL ?? ""}/api/MenuItem`;

export type EditMenuItemPayload = {
  id: number;
  menuItem: Dish;
};

export async function getAllMenuItems(): Promise<Dish[]> {
  const res = await fetch(`${BASE_URL}/GetAllMenuItems`);

  if (!res.ok) throw new Error("Failed to fetch menu items");
  return res.json();
}

export async function getAllMenuItemsNotInWeeklyMenu(): Promise<Dish[]> {
  const res = await fetch(`${BASE_URL}/GetAllMenuItemsNotInWeeklyMenu`);

  if (!res.ok) throw new Error("Failed to fetch menu items not yet in weekly");
  return res.json();
}

export async function addMenuItem(item: Dish): Promise<Dish> {
  const res = await fetch(`${BASE_URL}/AddMenuItem`, {
    method: "POST",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to add menu item");
  return res.json();
}

export async function editMenuItem(item: EditMenuItemPayload): Promise<Dish> {
  const res = await fetch(`${BASE_URL}/EditMenuItem`, {
    method: "PUT",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to edit menu item");
  return res.json();
}

export async function deleteMenuItem(item: number): Promise<Dish> {
  const res = await fetch(`${BASE_URL}/DeleteMenuItem`, {
    method: "DELETE",
    headers: {"Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}`},
    body: JSON.stringify(item),
  });

  if (!res.ok) throw new Error("Failed to delete menu item");
  return res.json();
}

export async function deleteImage(fileName: string): Promise<void> {
  const res = await fetch(
    `${BASE_URL}/RemoveMenuItemImage?fileName=${encodeURIComponent(fileName)}`, {
      method: "POST",
      headers: {"Authorization": `Bearer ${localStorage.getItem("token")}`},
    });

  if (!res.ok) throw new Error("Failed to delete image");
}

  export async function uploadImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${BASE_URL}/UploadMenuItemImage`, {
      method: "POST",
      body: formData,
      headers: {"Authorization": `Bearer ${localStorage.getItem("token")}`},
    });

    if (!res.ok) throw new Error("Failed to upload image");
    const data = await res.json();
    return data.picturePath;
  }